import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { motion } from 'motion/react'

import { useBrandStore } from '@jotta/ui/useBrandTheme'

export const WebappModuleNav = observer(() => {
  const brandStore = useBrandStore()

  const moduleNavOverlay = brandStore.getSlot('moduleNavOverlay')
  const moduleNav = brandStore.getSlot('moduleNav')
  const [showModuleNavContent, setShowModuleNavContent] = useState(!!moduleNav)

  useEffect(() => {
    if (moduleNav && !moduleNavOverlay) {
      setShowModuleNavContent(true)
    }
  }, [moduleNav, moduleNavOverlay])

  if (!moduleNav && !moduleNavOverlay) {
    return null
  }

  // If overlay is present, animate out moduleNav content and shadow in together, then overlay content
  // If no overlay, just show moduleNav content
  return (
    <div className="relative pb-3">
      <div className="relative z-moduleNav flex h-[64px] items-center bg-primary px-4 lg:rounded-xl">
        {/* ModuleNav content: fades out if overlay is present */}
        {showModuleNavContent && moduleNav && (
          <motion.div
            ref={moduleNav}
            className="z-moduleNav flex h-full w-full items-center px-4"
            aria-hidden={Boolean(moduleNavOverlay)}
            initial={{ opacity: 1 }}
            animate={{ opacity: moduleNavOverlay ? 0 : 1 }}
            transition={{
              duration: 0.5,
              ease: [0.4, 0, 0.2, 1],
            }}
            style={{ position: 'absolute', inset: 0 }}
            onAnimationComplete={() => {
              // Remove from DOM after fade-out
              if (moduleNavOverlay) {
                setShowModuleNavContent(false)
              }
            }}
          />
        )}
      </div>
      {/* Shadow: animates in at the same time as moduleNav content fades out */}
      {moduleNavOverlay && (
        <motion.div
          className="pointer-events-none absolute inset-0 z-moduleNavOverlayShadow h-[64px] rounded-xl shadow-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.5,
            ease: [0.4, 0, 0.2, 1],
          }}
        />
      )}
      {/* Overlay: only animates in after shadow */}
      {moduleNavOverlay && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 0.1,
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1],
          }}
          ref={moduleNavOverlay}
          className="absolute inset-0 z-moduleNavOverlay flex h-[64px] items-center"
        />
      )}
    </div>
  )
})
